export const LOCAL_ADDRESS = 'localhost:8080';
export const DEPLOY_ADDRESS = 'give-portfolio.shop';

export default function getServerAddress() {
    return DEPLOY_ADDRESS;
}